<template>
    <b-navbar-nav>
        <b-nav-item v-for="item in defaultMenu" :to="item.path" :key="item.name">
            {{ $t(item.meta.title) }}
        </b-nav-item>
    </b-navbar-nav>
</template>

<script>
export default {
    name: 'menuItems',
    computed: {
        isInspector: function () {
            return this.$store.getters.getUserRole === this.$appConfig.role.inspector
        },
        isInDealerCabinet: function () {
            return /\/dealers\/\d\/?/gi.test(this.$route.path)
        },
        customMenu: function () {
            return this.$router.getMenu(this.$appConfig.role.dealer)
        },
        defaultMenu: function () {
            return this.$router.getMenu()
        }
    }
}
</script>
